import { styled } from '../../../../theme/styled';

export const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledLegalContentHTML = styled.div`
  p,
  li {
    margin-bottom: ${(props) => props.theme.sizes.medium};
    color: ${(props) => props.theme.configuration.primaryTextColor};
  }
  p,
  table {
    font-size: ${(props) => props.theme.sizes.small};
  }
  a {
    color: ${(props) => props.theme.configuration.primaryTextColor};
  }
  td > p {
    min-width: 150px;
  }
  #container > p:first-child,
  h1 {
    font-size: ${(props) => props.theme.typography.h1.fontSize};
    color: ${(props) => props.theme.configuration.primaryTextColor};
  }

  /* This is the style for bullet lists */
  ul {
    margin-top: ${(props) => props.theme.sizes.medium};
    padding-left: ${(props) => props.theme.sizes.medium};
    font-size: ${(props) => props.theme.sizes.small};
  }

  /* This is the style for the ordered lists */
  ol {
    margin-top: ${(props) => props.theme.sizes.medium};
    font-size: ${(props) => props.theme.sizes.small};
    padding: 0;

    /* This allow us to have subitems count 1.2, 1.3 etc */
    counter-reset: item;
  }

  ol ol,
  ol ul {
    padding-left: ${(props) => props.theme.sizes.xxsmall};
  }

  ol li,
  ul li {
    &.bold-list-item:before {
      font-weight: ${(props) => props.theme.font.weights.semiBold};
    }
  }

  /* This is the first level list items */
  ol > li {
    font-size: ${(props) => props.theme.sizes.normal};

    /* This removes the padding so that we flush things to the left */
    display: block;
  }

  ol > li:before {
    font-weight: ${(props) => props.theme.font.weights.regular};
    content: counters(item, '.') '. ';
    counter-increment: item;
  }

  /* This is the second level list items */
  ol > li > ol > li {
    font-size: ${(props) => props.theme.sizes.small};
  }

  ol > li > ol > li:before {
    font-weight: ${(props) => props.theme.font.weights.regular};
    content: counters(item, '.') ' ';
    counter-increment: item;
  }

  ol.list-type-alpha > li:before {
    content: counter(item, lower-alpha) '. ';
  }

  ol.list-type-upper-roman > li:before {
    content: counter(item, upper-roman) '. ';
  }

  ol.list-type-lower-roman > li:before {
    content: counter(item, lower-roman) '. ';
  }

  /* This is for the occurences of numeric lists outside of the hierarchy*/
  ol .styleType-decimal {
    list-style-type: decimal;
  }

  /* This is for the table in some TnC's */
  tr {
    vertical-align: top;
    hyphens: auto;
  }

  tr a {
    hyphens: none;
  }
`;

export const ChromelessPageWrapper = styled.div`
  padding: ${(props) => props.theme.sizes.medium};
  width: 100%;
  height: 100%;
`;
